import { validationFns } from "../../components/form/validations";
import { OrgCreateInput } from "../../schema/types/org/create";
import { formSet } from "../gvc/testNewForm/utils";

export function getValidatorCreate(id: string) {
  return async function validator(v: OrgCreateInput): Promise<boolean | null> {
    // setup
    formSet(id, `meta.valid`, false);
    formSet(id, `meta.validating`, true);
    formSet(id, `errors`, {});
    formSet(id, `warnings`, {});

    const e: Partial<Record<string, { message: string }>> = {};
    const w: Partial<Record<string, { message: string }>> = {};

    function setError(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      e[path] = { message: message };
    }

    function setWarning(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      const currentWarning = w[path];
      if (currentWarning) {
        return;
      }
      w[path] = { message: message };
    }

    // setup end

    try {
      const fs = validationFns("Name");
      for (const f of [fs.required, fs.name]) {
        const r = f(v.name);
        if (r !== true) {
          setError(`name`, r);
        }
      }

      if (!v.accountId) {
        setError(`accountId`, `Billing Account Selection is required`);
      }

      // invitees start
      for (const inviteeStr in v.invitees) {
        const inviteeIndex = Number(inviteeStr);
        const invitee = v.invitees[inviteeIndex];
        if (!invitee.value) {
          setError(`invitees.${inviteeIndex}.value`, "Invitee is required");
          setError(`inviteesroot`, "Either type an invitee or remove the item");
        }
      }
      // invitees end

      // setup
      for (const path of Object.keys(e)) {
        const value = e[path];
        formSet(id, `errors.${path}`, value);
      }
      for (const path of Object.keys(w)) {
        const value = w[path];
        formSet(id, `warnings.${path}`, value);
      }

      const hasErrors = Object.keys(e).length > 0;

      formSet(id, `meta.valid`, !hasErrors);
      formSet(id, `meta.validating`, false);

      return hasErrors;
    } catch (e) {
      formSet(id, `errors`, { root: e.message });
      return true;
    }
  };
}
